import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

import ZOOM_AUDIT_TRAIL_SWIFT from "resources/code/ios/17-zoom-audit-trail.swift.tpl";
import ZOOM_AUDIT_TRAIL_OBJC from "resources/code/ios/17-zoom-audit-trail.m.tpl";
import ZOOM_AUDIT_TRAIL_JAVA from "resources/code/android/19-audit-trail.java.tpl";
import ZOOM_AUIDT_TRAIL_JS from "resources/code/web/07-zoom-audit-trail.js.tpl";
import ZOOM_TIME_BASED_IMAGES_SWIFT from "resources/code/ios/38-time-based-images.swift.tpl";
import ZOOM_TIME_BASED_IMAGES_OBJC from "resources/code/ios/38-time-based-images.m.tpl";
import ZOOM_TIME_BASED_IMAGES_JAVA from "resources/code/android/37-time-based-images.java.tpl";
import ZOOM_TIME_BASED_IMAGES_JS from "resources/code/web/time-based-images.js.tpl";
import facetec_3d_facemap_examples from "resources/img/facetec-3d-facemap-examples.png";
import facetec_audit_trail_examples from "resources/img/facetec-audit-trail-examples.png";
import facetec_id_scan_examples from "resources/img/facetec-id-scan-examples.png";

export default React.createClass({
  displayName: "zoom-audit-trail",
  scrollToGuide : null,
  scrollingEl: null,
  getInitialState: function() {
    var data  = [{name: "Audit Trail Images"},
                 {name: "Time Based Session Images"},
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      error: "",
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="audit-trail-and-id-scan-images">Audit Trail & ID Scan Images</h2>
                </div>
                <p>Learn about Audit Trail & ID  Scan Images, images that are returned by the FaceTec Device SDK after performing a 3D Liveness Check and/or Photo ID Match.</p>
                <hr/>
              </section>

              <section>
                <h3 id="introduction">Introduction</h3>
                <p>
                While FaceTec performs real-time processing on the Video Selfie and creates the 3D FaceMap, it also sets aside some Audit Trail images of the User. If a subsequent ID Scan is performed, then images of that ID Document are also returned.
                </p>
                <hr />
              </section>

              <section>
                <h3 id="overview">Overview</h3>
                <h4 id="data-3d-facemap">3D FaceMaps</h4>
                <p>3D FaceMaps (350kb) are reverse engineered from 100+ video frames captured during ~2 second User Selfie. 3D FaceMaps are always encrypted and aren't human viewable, but if 3D FaceMaps were to be rendered, this is what they would look like:</p>
                <p style={{textAlign: "left"}}><img style={{marginTop: "1px"}} src={facetec_3d_facemap_examples}  width="30%" /></p>
                <h4 id="data-audit-trail-image">Audit Trail Images</h4>
                <p>Audit Trail Images (JPEGs) of the User are accessible by Developers in each User Session.</p>
                <p style={{textAlign: "left"}}><img style={{marginTop: "1px"}} src={facetec_audit_trail_examples}  width="30%" /></p>
                <h4 id="data-id-scan">ID Scans</h4>
                <p>ID Scan High Resolution Images (JPEGs) from each ID Scan are accessible by Developers for each ID Scan attempt.</p>
                <p style={{textAlign: "left"}}><img style={{marginTop: "1px"}} src={facetec_id_scan_examples}  width="50%" /></p>
                <hr />
              </section>

              <section>
                <h3 id="retrieving-audit-trail-images-and-id-scan-images">Retrieving Audit Trail Images and ID Scan Images</h3>
                <p>
                  The FaceTec Audit Trail provides back to the application high quality, far out (small oval phase), 2D images captured from the User Session.  These images can be used for fraud investigation, transaction validation, and matching to identity documentation.  <strong>FaceTec Audit Trail Images may NOT be used in any 3rd party Face Matching or Face Liveness systems, and may NOT be used to train or test ML/AI algorithms.</strong>
                </p>
                <p>
                  When using Photo ID Match, high quality & high resolution images of the ID Scan can be found on the <code>ZoomIDScanResult</code> object.  <strong>FaceTec ID Scan Images may be used in 3rd party ID Verification systems, but may NOT be used to train or test ML/AI algorithms.</strong>
                </p>
                <blockquote>
                  <p>You can access Audit Trail Images via the <code>ZoomSessionResult</code> object's <code>faceMetrics.auditTrailCompressedBase64</code> property.</p>
                  <p>You can access ID Scan Images via the <code>ZoomIDScanResult</code> object's <code>idScanMetrics.frontImages</code> and <code>idScanMetrics.backImages</code> properties.</p>
                </blockquote>

                <hr />
              </section>

              <section>
                <h3 id="retrieving-low-quality-audit-trail-images">Retrieving Low Quality Audit Trail Images</h3>
                <p><strong>New in recent releases</strong>: Developers now have access to another set of images called the <strong>Low Quality Audit Trail Images</strong>.  If the User Session requires the User to Retry, these images are representative of the likely cause of the rejection.  Often times these will be blurry, poorly lit, poor pose, or otherwise bad quality images that the User presented to the camera.</p>
                <blockquote>
                  <p>You can access Low Quality Audit Trail Images via the <code>ZoomSessionResult</code> object's <code>faceMetrics.lowQualityAuditTrailCompressedBase64</code> property.</p>
                </blockquote>
                <hr />
              </section>

              <section>
                <h3 id="return-types">Return Types</h3>
                <p>
                  The FaceTec Audit Trail and ID Scan Images is returned back to developers in the <code>ZoomSessionResult.faceMetrics</code> and <code>ZoomIDScanResult.idScanMetrics</code> objects.
                </p>
                <p>On iOS, an <code>Array of String (base64 encoded JPEGs)</code> is returned.</p>
                <p>On Android, a <code>ArrayList of String (base64 encoded JPEGs)</code> is returned.</p>
                <p>On Browser, a <code>Array of String (base64 encoded JPEGs)</code> is returned.</p>
                <hr />
              </section>

              <section>
                <h3 id="audit-trail-image-selection">Audit Trail Image Ordering</h3>
                <p>
                FaceTec currently returns up to 6 frames (exactly 6 in most cases).  The strategy for what type of frames to return is as follows:
                </p>
                <ol>
                  <li><p> Always attempt to return high quality, frontal, non-blinking frames.</p></li>
                  <li><p> <strong>The first image in the audit trail will generally be the best image of the user.</strong>  This image is most similar to the rest of the session and is of the highest quality based on a variety of metrics.</p></li>
                  <li><p> <strong>The second image in the audit trail is the least similar image to the first image.</strong>  This is in an effort to get diversity in the returned images.  This is useful for auditing, analysis, or building a diverse profile for the user.</p></li>
                  <li><p> <strong>The third image in the audit trail is the frame where the users' eyes are the most open.</strong>  Other images also attempt to get eyes open images, but this particular index is more tuned to retrieving a non-blinking frame.</p></li>
                  <li><p> <strong>Images 4-6 in the audit trail are the next 3 highest quality frames from the session.</strong></p></li>
                </ol>
                <hr />
              </section>

              <section>
                <h3 id="audit-trail-image-selection">Low Quality Audit Trail Image Ordering</h3>
                <p>
                FaceTec currently returns up to 6 frames (exactly 6 in most cases) in the Low Quality Image Audit Trail.  The strategy for what type of frames to return is to return an ordered list where the first element in the list is the worst quality image from the session, and representative of the likekly cause of failure.
                </p>
                <hr />
              </section>

              <section>
                <h3 id="audit-trail-resolution">Audit Trail Resolution</h3>
                <p>By setting <code>ZoomSDK.auditTrailType</code> to <code>.Height640</code>, the returned Audit Trail Image will be resized to have a height of 640 while maintaining the aspect ratio of the image captured by the device.  This means the width of the Audit Trail Image may be different depending on the device being used.</p>
                <p>By setting <code>ZoomSDK.auditTrailType</code> to <code>.FullResolution</code>, the returned Audit Trail Image can be taller than 640 pixels.  Note that the resolution of the Audit Trail Image will not always be the same as the full resolution that the device is capable of.  This is because we make optimizations on our processing to reduce data and make biometric performance fast.</p>
                <hr />
              </section>

              <section>
                <h3 id="time-based-session-images">Time Based Session Images</h3>
                <p>In addition to the FaceTec SDK Audit Trail, FaceTec also captures images for the first several seconds of the User Session (even before processing starts) and can provide them back to the developer for security and auditing purposes.</p>
                <p>
                  When enabled, the Time Based Session Images feature provides developers with the first image ever collected, an image roughly 1 second into the User Session and an image roughly 2 seconds into the User Session. These can be used for additional fraud investigation and transaction validation.
                </p>
                <p>
                  There are some caveats to these images. FaceTec SDKs will only collect images at these times if they are at the far out, unzoomed distance (or smaller), or if no face is found in the image. If the image does not meet these requirements, then no image will be returned.
                </p>
                <p>
                  The array of Time Based Session Images will always be of size 3 with each index in the array corresponding to the capture time. Time 0 will be the 0th index in the array and so on. If no image was captured for that time during the User Session then the object in that array index will be null.
                </p>
                <p>The Time Based Session Images feature is disabled by default. To enable this functionality, set <code>ZoomSDK.enableTimeBasedSessionImages</code> to <code>true</code> prior to a verification.  Then, in the verification, you can access the images via <code>result.faceMetrics.timeBasedSessionImages</code> on the <code>ZoomSessionResult</code> object.</p>
                <p></p>
                <hr />
              </section>


              <section>
                <h3 id="acceptable-use">Acceptable Use</h3>
                <p>Developers may store and utilize the FaceTec SDK Audit Trail Images for internal use, but may not use the images or image data with any non-FaceTec face matching algorithm, in the development of human Liveness Detection technology, Photo ID Presentation Attack Detection technology, or Photo ID Document Tampering Detection technology, Optical Character Recognition (OCR) technology, or provide images or image data to any third party for use of any kind.</p>
              </section>

              <SDKSidebar menuType="main" title="Retrieving Images Guide"/>

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-audit-trail.jsx